export default "/assets/images/attic-video-thumbnail.jpg?be1867a598a2e1327bd8ee7376578aaf";